export default "if (a) {\n  b = c;\n  function foo(d) {\n      e = f;\n  }\n}\n"